import { useNavigate } from "react-router-dom";
import Reveal from "./Reveal";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  const navigate = useNavigate();
  return (
    <section className="w-full pt-12 md:pt-16 px-4 md:px-10 lg:px-16 bg-white">
      <Reveal>
        <div className="relative w-full rounded-3xl overflow-hidden">
          {/* Gradient Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#041122] via-[#2a0535] to-[#B3129E]" />

          {/* subtle pattern */}
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage:
                "radial-gradient(circle, white 1px, transparent 1px)",
              backgroundSize: "28px 28px",
            }}
          />

          <div className="relative z-10 py-14 md:py-20 px-8 md:px-14 text-center max-w-5xl mx-auto">
            <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase text-[#e8a0f0] mb-4">
              [ GET IN TOUCH ]
            </span>

            <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-heading font-semibold text-white leading-snug mb-4">
              Ready to Build Forever?
            </h2>

            <p className="text-white/70 text-sm md:text-base leading-relaxed mb-8 tracking-wider max-w-2xl mx-auto">
              Partner with Mix Masters RMC for precision-engineered ready-mix
              concrete solutions that deliver quality, strength, and reliability
              for every project.
            </p>

            {/* CTA */}
            <div className="flex justify-center">
              <button
                onClick={() => navigate("/contact")}
                className="inline-flex items-center gap-2 rounded-xl px-8 py-3 text-sm font-semibold text-white bg-[#B3129E] transition-all duration-200 hover:bg-[#8F0F7D] hover:-translate-y-[2px] hover:shadow-[0_8px_20px_rgba(179,18,158,0.35)]"
              >
                Contact Our Team
                <ArrowRight size={16} />
              </button>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default CTASection;
